import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import { useCallback } from 'react';

import type { SaveSearchParamsOrKey } from '@/redux/modules/search/save/saveSearch.helpers';

import { useAppDispatch } from '@/redux/hooks';
import { getSaveSearchResult, submitSaveSearch } from '@/redux/modules/search/save/saveSearch.actions';
import { SaveSearchResult } from '@/redux/modules/search/save/saveSearch.types';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

/**
 * Follows a search and tells the bidder when savedsearch-api refused it for invalid facet values,
 * which otherwise fails silently: the follow button just stays unfollowed.
 */
export const useSubmitSaveSearch = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    return useCallback(
        async (saveSearchParams: SaveSearchParamsOrKey, sendAlert: boolean) => {
            const result = getSaveSearchResult(await dispatch(submitSaveSearch({ saveSearchParams, sendAlert })));
            if (result === SaveSearchResult.InvalidFacets) {
                toast('error', {
                    description: formatMessage(['toastMessages', 'descriptions', 'searchNotSavedInvalidFilters']),
                    title: String(formatMessage(['toastMessages', 'titles', 'searchNotSaved'])),
                });
            }
            return result;
        },
        [dispatch, formatMessage]
    );
};
